<template>
  <div id='' class='gPageBorder' v-loading='loading'>

    <el-dialog
      class=''
      :title="$t('app_tip')"
      :visible.sync="cerDialogVisible"
      size="tiny"
      before-close="">
      <span>{{cerTipMsg}}</span>
      <span slot="footer" style='text-align:center'>
        <el-button @click="cerDialogVisible = false">{{$t('app_cancel')}}</el-button>
        <!-- <el-button type="primary" @click="pushCreateCer">{{$t()}}</el-button> -->
        <el-button type="primary" @click="pushUploadCer">{{$t('app_uploadCer')}}</el-button>
      </span>
    </el-dialog>

    <el-dialog
      class=''
      :title="$t('app_tip')"
      :visible.sync="cerTipDialogVisible"
      size="tiny"
    before-close="">
      <span>{{cerTipMsg}}</span>
      <span slot="footer" style='text-align:center'>
        <el-button type='primary' @click="cerTipDialogVisible = false">{{$t('app_sure')}}</el-button>
      </span>
    </el-dialog>


    <el-dialog  class='gDia' :title="$t('app_addPush')" v-model="dialogVisible" size='middle'>
      <div v-loading='dvLoading'>  
      <div style='width:100%;background:none;text-align:left;' class='gDiaTable'>
        
        <span>
          
          <el-select @change='selectDvChange' style='width:16%;margin-right:10px;' v-model="channelId" clearable :placeholder="$t('app_distributor')">
            <el-option
              v-for="item in channels"
              :key="item.mechanismid"
              :label="item.mechanismname"
              :value="item.mechanismid">
            </el-option>
          </el-select>
        </span>

        <span>
          
          <el-select @change='selectDvChange' style='width:16%;margin-right:10px;' v-model="status" clearable :placeholder="$t('app_status')">
            <el-option
              v-for="item in stModel"
              :key="item.vl"
              :label="item.label"
              :value="item.vl">
            </el-option>
          </el-select>
        </span>
           

        <el-input
        :placeholder="$t('app_searchTerminal')"
        icon="search"
        @keyup.enter.native='srchDevice'
        style='width:40%;margin-bottom:10px;'
        v-model="srchValue">
        </el-input>
      </div>

      


      <el-table
      :data="dvTableData"
      border
      tooltip-effect="dark"
      style="width: 100%">
       
        <el-table-column
          align='center'
          prop="terminalName"
          :label="$t('app_terName')"
          width="130">
        </el-table-column>

        <el-table-column
          align='center'
          prop="mechName"
          :label="$t('app_distributor')"
          width=''>
        </el-table-column>

        <el-table-column
          prop="terminal_status"
          align='center'
          :label="$t('app_status')"
          width="90">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.terminalStatus == 1 " type="success" size="mini">{{$t('app_online')}}</el-tag>
                    <el-tag v-if="scope.row.terminalStatus == 2 " type="danger" size="mini">{{$t('app_offline')}}</el-tag>
                    <el-tag v-if="scope.row.terminalStatus == 0 " type="gray" size="mini">{{$t('app_new')}}</el-tag>
          </template>
        </el-table-column>
        
        <el-table-column
          prop="operate"
          :label="$t('app_operate')"
          align='right'
          header-align="center"
          width='80'>
          <template slot-scope='scope'>
            <!-- <el-button  @click='bindOperate(scope.row)' type=text>{{$t('app_push')}}</el-button> -->
            <el-tooltip class="item" effect="dark" :content="$t('app_push')" placement="top">
              <el-button type='text' @click='bindOperate(scope.row)'><i class="fa fa-upload" style=""></i></el-button>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>

      <div class="block" style=''>

        <el-pagination
        @current-change="pageDvSelect"
        @size-change="pageDvSized"
        :current-page="dvIndex"
        :page-sizes='$gRows'
        :page-size="$gRow"
        layout="total, sizes, prev, pager, next, jumper"
        :total="dvTotal">
        </el-pagination>
        <!-- <el-pagination
          small
          layout="prev, pager, next"
          :total="dvTotal">
        </el-pagination> -->

      </div>
      </div>
    </el-dialog>

    <div id=''>
      <div style=''>

        <el-row>
          <el-col :span="16" class=''>
            <el-button class='gSgLeftBtn' type='primary' @click='jumpToUpload'>{{$t('app_addlc')}}</el-button>
          </el-col>

          

          <el-col :span="4">
            <div class='gCtrl'>
              <!-- <el-select  v-model="appType" clearable :placeholder="$t('app_type')" @change='selectChange'>
                <el-option
                  v-for="item in appTypes"
                  :key="item.appClassifyId"
                  :label="item.appClassifyName"
                  :value="item.appClassifyId">
                </el-option>
              </el-select> -->
              <MechanismSelector style='' :data="mechanismData"></MechanismSelector>
            </div>
          </el-col>
            

          <el-col :span="4">
            <div class='gSideCtrl'>
              <el-input  :placeholder="$t('app_lcname')" v-model='queryKey' @keyup.enter.native='query' icon="search" :on-icon-click="query"></el-input>
            </div>
          </el-col>

        </el-row>
        
        
      </div>
    </div>


    <!-- <div id='adFilter' v-show=0>
      <label>{{$t('app_filter')}}:</label>
      <el-select style='width:16%;margin-left:20px;' v-model="appTypeValue" clearable :placeholder="$t('app_type')">
        <el-option
          v-for="item in appTypes"
          :key="item.appClassifyId"
          :label="item.appClassifyName"
          :value="item.appClassifyId">
        </el-option>
      </el-select>
      <el-select style='width:16%;margin-left:20px;' v-model="appStatusValue" clearable :placeholder="$t('app_status')">
        <el-option
          v-for="item in appStatus"
          :key="item.value"
          :label="item.label"
          :value="item.value">
        </el-option>
      </el-select>
    </div> -->

    <div id=''>
      <el-table
        @row-click='cellClick'
        :data="tableData"
        border
        @sort-change="sortChange"
        class='tbPoint gTopMg'
        style="width: 100%;border:none;">
        
        <el-table-column
          header-align='center'
          align='center'
          prop="launchername"
          sortable="custom"
          :label="'launcher' + $t('app_name')"
          width="">
        </el-table-column>
        
        <el-table-column
          header-align='center'
          align='center'
          prop="distrabutorname"
          width=''
          :label="$t('app_distributor')">
        </el-table-column>
        <el-table-column
          header-align='center'
          align='center'
          prop="status"
          width='115'
          :label="$t('app_vStatus')">
          <template slot-scope='scope'>
            <label :style='getStatus(scope.row.status).style'>{{getStatus(scope.row.status).vl}}</label>
          </template>
        </el-table-column>

        <el-table-column
          header-align='center'
          align='center'
          prop="version"
          width='120'
          :label="$t('app_newgVer')">
        </el-table-column>

        <el-table-column
          header-align='center'
          align='center'
          prop="uploadtime"
          sortable="custom"
          width='175'
          fformatter="dateFormat"
          :label="$t('app_ulTime')">
        </el-table-column>
        
        <el-table-column
          header-align='center'
          align='right'
          prop="operate"
          width='122'
          :label="$t('app_operate')">
          <template slot-scope='scope'>

            <span style='background:none;'>

            <!-- <el-button v-show="scope.row.status === '2'" type=text @click='pushApp(scope.row)'>{{$t('app_push')}}</el-button> -->
            <!-- <el-tooltip class="item" effect="dark" :content="$t('app_push')" placement="top">
              <el-button v-show="scope.row.status === '2'" type=text @click='pushApp(scope.row)'><i class="fa fa-upload" style=""></i></el-button>
            </el-tooltip> -->

            <!-- <el-button v-show="(scope.row.status !== '1' && scope.row.status !== '2') && scope.row.isoperate === 0" type=text @click='editApp(scope.row)'>{{$t('app_edit')}}</el-button> -->
            <el-tooltip class="item" effect="dark" :content="$t('app_edit')" placement="top">
              <el-button v-show="(scope.row.status !== '1' && scope.row.status !== '2') && scope.row.isoperate === 0" type=text @click='editApp(scope.row)'><i class="fa fa-pencil" style=""></i></el-button>
            </el-tooltip>

            <!-- <el-button v-show="scope.row.status !== '1' && scope.row.status !== '2' && scope.row.isoperate === 0" @click='submitApp(scope.row)' type='text'>{{$t('app_smVerify')}}</el-button> -->
            <el-tooltip class="item" effect="dark" :content="$t('app_smVerify')" placement="top">
              <el-button v-show="scope.row.status !== '1' && scope.row.status !== '2' && scope.row.isoperate === 0" @click='submitApp(scope.row)' type='text'><i class="fa fa-external-link-square" style=""></i></el-button>
            </el-tooltip>

            <!-- <el-button v-show='scope.row.isoperate === 0' type=text @click='deleteApp(scope.row)'>{{$t('app_del')}}</el-button> -->
            <el-tooltip class="item" effect="dark" :content="$t('app_del')" placement="top">
              <el-button type='text'v-show='scope.row.isoperate === 0' @click='deleteApp(scope.row)'><i class="fa fa-trash-o" style="color:#FF4949"></i></el-button>
            </el-tooltip>
            
            </span>
          </template>
        </el-table-column>
      </el-table>

      <div class="gPgDiv" style=''>
        <el-pagination
        class='gPg'
        @current-change="pageSelect"
        @size-change="pageSized"
        :current-page="index"
        :page-sizes='$gRows'
        :page-size="$gRow"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
        </el-pagination>
      </div>
    </div>

  </div>
</template>

<style>
  /* html,body{width:100%;height:100%;}*/

  .tbPoint td{cursor:pointer}

  .cmMarginFrame{width:calc(100% - 20px);height:100%;background:none;margin-left:10px;}

  #appDepot{min-width:840px;}

  #adData{}

  
    
</style>

<script>
  import MechanismSelector from '@/components/global/mechanism_selector.vue'
  import mm from 'moment'
  export default{
    components: {
      MechanismSelector
    },
    data () {
      var that = this
      return {
        orderName: '',
        orderType: '',
        mechanismData: {
          callback (value) {
            that.mech = value
            that.selectChange(value)
          }
        },
        listKey: 'launch-list',
        cerDialogVisible: false,
        cerTipDialogVisible: false,
        dvLoading: 0,
        appId: '',
        stModel: [
          {label: this.$t('app_online'), vl: '1'},
          {label: this.$t('app_offline'), vl: '2'},
          {label: this.$t('app_new'), vl: '0'}
        ],
        channels: [],
        srchValue: '',
        channelId: '',
        cerTipMsg: '',
        status: '',
        dvIndex: 1,
        dialogVisible: 0,
        mechanismId: window.localStorage['mechanismId'],
        selectMid: '',
        tableData: [],
        dvTableData: [],
        appTypes: [],
        appTypeValue: '',
        appStatus: [
          {label: this.$t('app_prePushVerify'), value: '0'},
          {label: this.$t('app_preVerify'), value: '1'},
          {label: this.$t('app_verifyPass'), value: '2'},
          {label: this.$t('app_verifyNotPass'), value: '3'}],
        appStatusValue: '',
        total: 0,
        dvTotal: 0,
        loading: 0,
        appType: '',
        queryKey: ''
      }
    },
    computed: {
      index () {
        var vl = this.$getWPage(this.listKey)
        return vl ? vl : 1
      },
      getDvStatus (value) {
        switch (value) {
          case '0':
            return this.$t('app_prePushVerify')
          case '1':
            return this.$t('app_preVerify')
          case '2':
            return this.$t('app_verifyPass')
          case '3':
            return this.$t('app_verifyNotPass')
        }
      }
    },
    methods: {
      sortChange (vl) {
        switch (vl.prop) {
          case 'launchername':
            this.orderName = '1'
            break
          case 'uploadtime':
            this.orderName = '2'
            break
        }
        this.orderType = vl.order == 'descending'? 'desc':'asc'
        this.getList()
      },
      pushCreateCer () {
        this.$router.push({path: "/certificate/new"})
      },
      pushUploadCer () {
        this.$router.push({path: "/certificate/upload"})
      },
      bindOperate (row) {
        //console.log(row)
        
        this.dvLoading = 1
        if (this.$appUrlTag === 0) {
          this.$bindApp('0', row.terminalNo, this.appId, (res) => {
            if (res.status === 200) {
              this.$message.success(this.$t('app_tipViewTask'))
            } else {
              this.$message.error(res.message)
            }
            this.dvLoading = 0
          }, () => {
            // error
            this.dvLoading = 0
          })
        } else {
          // console.log(localStorage.mechanismId, tNo)
          this.$bindApp1(localStorage.mechanismId, row.terminalNo, this.appId, (res) => {
            if (res.status === 200) {
              this.$message.success(this.$t('app_tipViewTask'))
            } else {
              this.$message.error(res.message)
            }
            this.dvLoading = 0
          }, () => {
            // error
            this.dvLoading = 0
          })
        }
      },
      getChannels () {
        this.$getChannelList(10000, 1, '','','', (res) => {
          if (res.status === 200) {
            this.channels = res.data
          } else {
            this.$message.error(res.message)
          }
        }, () => {
          // error
          this.$message.error(this.$t('app_rqsError'))
        })
      },
      getStatus (value) {
        if (!value) return ''
        switch (value) {
          case '0':
            return {vl: this.$t('app_prePushVerify'), style: 'color:#8492A6;'}
          case '1':
            return {vl: this.$t('app_preVerify'), style: 'color:#F7BA2A;'}
          case '2':
            return {vl: this.$t('app_verifyPass'), style: 'color:#13CE66;'}
          case '3':
            return {vl: this.$t('app_verifyNotPass'), style: 'color:#FF4949;'}
        }
      },
      srchDevice () {
        this.getDevices()
      },
      selectDvChange (vl) {
        this.getDevices()
      },
      pageDvSized (val) {
        this.$gRow = val
        this.getDevices()
      },
      getDevices () {
        var vl = this.srchValue ? this.srchValue : ''
        var channel = this.channelId ? this.channelId : ''
        var status = this.status ? this.status : ''
        var appId = this.appId ? this.appId : ''
        this.dvLoading = 1
        if (this.$appUrlTag === 0) {
          this.$getDevices(this.dvIndex, this.$gRow, channel, vl, status, '', appId, (res) => {
            // console.log('dv', res)
            this.dvLoading = 0
            if (res.data) {
              this.dvTableData = res.data
              this.dvTotal = res.total
            }
          }, () => {
            // error
            this.dvLoading = 0
          })
        } else {
          
          this.$getDevices1(this.dvIndex, this.$gRow, localStorage.mechanismId, vl, status, '', appId, (res) => {
            console.log('dv', res)
            this.dvLoading = 0
            if (res.data) {
              this.dvTableData = res.data
              this.dvTotal = res.total
            }
          }, () => {
            // error
            this.dvLoading = 0
          })
        }
        
      },
      editApp (row) {
        this.$setWObj('launcherEdit', {type: 1, data: row})
        this.$router.push({path: '/launch-edit'})
      },
      pushApp (row) {
        
        //this.$setWObj('launcherPush', row)
        //this.$router.push({path: '/launch-push'})

        this.$setWObj('pushList', {type: '10', data: row})
        this.$router.push({path: '/launch-push'})
       
      },
      query () {
        this.getList()
      },
      selectChange (vl) {
        this.selectMid = vl
        this.getList()
      },
      reset () {
        this.queryKey = ''
        this.appType = ''
        this.getList()
      },
      pageSelect (index) {
        this.$setWPage(this.listKey, index)
        this.getList()
      },
      pageDvSelect (index) {
        this.dvIndex = index
        this.getDevices()
      },
      pageSized (val) {
        this.$gRow = val
        this.getList()
      },
      deleteApp (obj) {
        this.$showConfirm(this.$t('app_tip'), this.$t('app_isDelData'), this.$t('app_sure'), this.$t('app_cancel'), 'warning', () => {
          console.log(obj)
          this.$delLauncher(obj.launcherid,  obj.status, (res) => {
            if (res.status === 200) {
              this.getList()
              this.$message.success(res.message)
            } else {
              this.$message.error(res.message)
            }
          }, '')
        }, '')
      },
      submitApp (obj) {
        this.$showConfirm(this.$t('app_tip'), this.$t('app_tipVerify'), this.$t('app_sure'), this.$t('app_cancel'), 'warning', () => {
          this.loading = 1
          this.$submitLauncher(obj.launcherid, (res) => {
            this.loading = 0
            if (res.status === 200) {
              this.getList()
              this.$message.success(res.message)
            } else {
              this.$message.error(res.message)
            }
          }, () => {
            this.loading = 0
          })
          
        }, '')
      },
      cellClick (row, ev, col) {
        if (col.label && col.label === this.$t('app_operate')) {
          return
        }
      
        //console.log(row)
        var isDetail = (row.status === '1' || row.status === '2')
        var path = isDetail ? '/launch-detail' : '/launch-edit'
        var key = isDetail ? 'launcherDetail' : 'launcherEdit'
        var obj = isDetail ? row : {type: 1, data: row}

        this.$setWObj(key, obj)
        this.$router.push({path: path})
        
      },
      jumpToUpload () {
        /*this.loading = 1
        this.$isCer(this.mechanismId, (res) => {
          this.loading = 0
          // console.log('cer', res)
          if (!res.data) {
            this.$setWObj('editAppConfig', {type: 0})
            //this.$router.push({name: this.$t('menu.appManageSub.uploadApp')})
          } else {
            //this.$message.error(res.message)
            //this.$router.push({path: "/certificate/new"})
            this.cerTipMsg = res.message
            var vl = localStorage.cerType
            if (vl === '0') {
              // self
              this.cerDialogVisible = true
            } else {
              // other
              this.cerTipDialogVisible = true
            }
            
          }
        }, () => {
          // this.$message(this.$t('app_rqsError'))
        })*/

        this.$setWObj('launcherEdit', {type: 0})
        this.$router.push({path: '/addlaunch'})
      },
      getList () {
        this.loading = 1
        var dsid = this.selectMid ? this.selectMid : '' //渠道商id
        var name = this.queryKey ? this.queryKey : ''
        this.$launcherList(this.index, this.$gRow, name, dsid, this.orderName, this.orderType, '', (res) => {
          
          this.loading = 0
          if (res.status === 200) {
            this.total = res.total
            this.tableData = res.data
          } else {
            this.$message(res.message)
          }
        }, () => {
          this.loading = 0
          this.$message.error(this.$t('app_rqsError'))
        })
      },
      dateFormat (row, column) {
        var date = row[column.property]
        if (date === undefined) {
          return ''
        }
        return mm(date).format('YYYY-MM-DD HH:mm:ss')
      },
      setInstallType (type) {
        return this.$installType[type]
      }
    },
    mounted () {
      
      //this.getChannels()
      this.getList()
      /*this.$getAppTypeList(100000000, 1, (res) => {
        if (res.status === 200) {
          this.appTypes = res.data
        } else {
          this.$message(res.message)
        }
      }, '')*/
    },
    destroyed () {
    }
  }
</script>



// WEBPACK FOOTER //
// list.vue?69febf94